require('./components/global');
require('./components/mobile');
require('./components/navigation');
require('./components/image-slider');
require('./components/motive-slider');
require('./components/product-slider');
require('./components/equalize');
require('./components/side-navigation');
require('./components/search');
require('./components/Powermail/MoreStepForm');
require('./components/powermail');
require('./components/cooper-stock-api');
require('./components/language-toggle');
require('./components/wiredata');
require('./components/popup');
require('./components/banderole');
require('./components/related-products');
require('./components/background-images');